/**
 * Created by Administrador on 30/10/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('specialInvoiceReportCtrl', specialInvoiceReportCtrl);

    specialInvoiceReportCtrl.$inject = ['userSession','datePickerService',
        'linkService', 'dateService', 'specialInvoiceReportService',
        'excelService','userService'];

    function specialInvoiceReportCtrl(userSession, datePickerService,
                                         linkService, dateService, specialInvoiceReportService,
                                         excelService,userService){
        var vm = this;
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.userSession = userSession.data;


        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterCustomerCorporate.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };


        vm.filterSepcialInvoiceReport = {
            user: null,
            fromDate: null,
            toDate: null
        };

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.generateOperations = function (isValid, form) {
            if(isValid){
                vm.transaction = {};
                vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
                vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);

                specialInvoiceReportService.getSpecialInvoiceReport(vm.transaction).then(function (response) {
                    if(response !== undefined) {
                        vm.report = response.data;
                        if(vm.report.invoices.length>0){
                            vm.isReport = true;
                        }else{
                            vm.isReport = false;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'special_sale_invoice_report');
        }

        vm.cancelGenerate = function() {
            vm.filterCustomerCorporate.currency = null;
            vm.isReport = false;
        };

        vm.exportPdf = function(){
            vm.transaction = {};
            vm.transaction.fromDate = dateService.dateTimeString(vm.filterCustomerCorporate.fromDate, 1);
            vm.transaction.toDate = dateService.dateTimeString(vm.filterCustomerCorporate.toDate, 2);
            specialInvoiceReportService.getSpecialInvoiceReportPdf(vm.transaction)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "special_sale_invoice_report.pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }
    }
})();
